import { useCallback } from 'react';
import { vscodeWebApi } from '@/lib/api';
import { ConfirmDialog } from '@/components/ui-new/dialogs/ConfirmDialog';

/**
 * Hook to open a workspace in VS Code Web
 *
 * For dev mode (localhost): Returns URL with ?tkn= query parameter
 * For prod mode (sub-domain): Uses verify-with-cookie to set cookie
 *
 * @param workspaceId - The workspace ID to open
 */
export function useOpenInVscodeWeb(workspaceId?: string) {
  return useCallback(async (): Promise<void> => {
    if (!workspaceId) return;

    try {
      // Use verify-with-cookie which handles both dev and prod modes
      // For prod, it sets the cookie; for dev, it returns URL with token in query
      const response = await vscodeWebApi.verifyWithCookie(workspaceId);

      // Open the URL in a new tab
      if (response.url) {
        window.open(response.url, '_blank');
      }
    } catch (err) {
      console.error('Failed to open in VS Code Web:', err);
      const message =
        err && typeof err === 'object' && 'message' in err
          ? String(err.message)
          : 'Failed to open VS Code Web. Please check your configuration.';
      ConfirmDialog.show({
        title: 'Error',
        message,
        variant: 'destructive',
        confirmText: 'OK',
        showCancelButton: false,
      });
    }
  }, [workspaceId]);
}